module.exports = __webpack_public_path__ + "public/img/kd-title.e694e9ec.png";